import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@teo/components';
import { useState } from 'react';
import { axios } from '@/axios';
import { config } from '@/config';
import { useGet } from '@/query/fetchHooks';
import AddProfileList from './AddProfileList';

function AssignProfiles({
  isOpen,
  onClose,
  onSaved,
  organisationId,
  targetId,
  targetName,
  targetType,
}) {
  const { t } = useTranslation();

  const [currentProfiles, setcCurrentProfiles] = useState([]);
  const [newProfiles, setNewProfiles] = useState([]);

  const [deleteList, setDeleteList] = useState([]);
  const [addList, setAddList] = useState([]);

  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  const currentProfilesResult = useGet(
    targetType === 'team'
      ? '/teamprofessiondetails'
      : '/organisationstudentprofessiondetails',
    {
      organisationId,
      ...(targetType === 'team' ? { teamId: targetId } : { userId: targetId }),
      count: 1000,
      sort: 'professionName',
      enabled: isOpen,
      onSuccess: (result) => {
        setNewProfiles(result?.data || []);
        setcCurrentProfiles(result?.data || []);
      },
    }
  );

  const handleSave = async () => {
    if (isSaving) return;

    setIsSaving(true);
    setError('');

    try {
      await Promise.all([
        ...addList.map((profile) =>
          targetType === 'team'
            ? axios.post(`${config.backend}/teamprofessions`, {
                teamId: Number(targetId),
                professionId: profile?.professionId,
              })
            : axios.post(`${config.backend}/studentprofessions`, {
                organisationId: Number(organisationId),
                userId: Number(targetId),
                professionId: profile?.professionId,
              })
        ),
        ...deleteList.map((profile) =>
          targetType === 'team'
            ? axios.delete(
                `${config.backend}/teamprofession/${targetId}/${profile.professionId}`
              )
            : axios.delete(
                `${config.backend}/studentprofession/${profile.delId}`
              )
        ),
      ]);
      document.body.style.overflow = 'unset';
      onSaved();
      onClose();
    } catch {
      setError(t('pages.profile_assignment.error'));
    } finally {
      setIsSaving(false);
    }
  };

  const isLoading = currentProfilesResult?.isLoading;

  return (
    <div className="overflow-hidden bg-white">
      <Modal isOpen={isOpen}>
        <Modal.Header onClose={onClose}>
          <h2 className="text-sm font-semibold">
            {t(
              'pages.create_edit_course.competence_profile_add.link_comp_prof'
            )}
            <span>{targetName}</span>
          </h2>
        </Modal.Header>

        <Modal.Body>
          <AddProfileList
            setDeleteList={setDeleteList}
            deleteList={deleteList}
            setAddList={setAddList}
            addList={addList}
            oldProfiles={currentProfiles}
            listProfiles={newProfiles}
            setNewProfiles={setNewProfiles}
            organisationId={organisationId}
            targetType={targetType}
          />
        </Modal.Body>
        <Modal.Footer cancelButtonLabel={t('button.cancel')} onCancel={onClose}>
          <div>
            <Button
              disabled={isLoading || isSaving}
              onClick={() => handleSave()}
            >
              {t('pages.profile_assignment.save')}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AssignProfiles;
